"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'limits.avatar.exceeded': 'Limite avatar raggiunto. Aggiorna il tuo piano per creare più avatar.',
    'limits.avatar.limitReached': 'Limite avatar: {limit} (aggiorna per crearne di più)',
};
